import { getInitialPageState } from 'components/Experiences/ExperienceOfferPage/utils'
import type { ExperienceOfferPageDispatchAction, ExperienceOfferPageState } from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateReducer'
import experiencePageStateReducer, { INITIAL_EXPERIENCE_PAGE_STATE } from 'contexts/Experience/ExperienceOfferPage/experienceOfferPageStateReducer'
import type { Dispatch } from 'react'
import { useMemo, useReducer } from 'react'
import { useLocation } from 'react-router'

type ReturnType = [ExperienceOfferPageState, Dispatch<ExperienceOfferPageDispatchAction>]

function useExperiencePageReducer(experience?: App.ExperienceOffer): ReturnType {
  const { search } = useLocation()
  const [state, dispatch] = useReducer(experiencePageStateReducer, INITIAL_EXPERIENCE_PAGE_STATE, () => getInitialPageState(experience, search))

  return useMemo<ReturnType>(() => {
    return [state!, dispatch]
  }, [state, dispatch])
}

export default useExperiencePageReducer
